import { render } from "./StatisticsEmpty.vue?vue&type=template&id=4e2abef3"
import script from "./StatisticsEmpty.vue?vue&type=script&lang=js"
export * from "./StatisticsEmpty.vue?vue&type=script&lang=js"

import "./StatisticsEmpty.vue?vue&type=style&index=0&id=4e2abef3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__